
/**
 *
 */

+function($){

  page.initSection = function() {

  }

}(jQuery);




//////////////////
// WEBPACK FOOTER
// ./assets/plugin/thesaas/js/partials/section.js
// module id = 78
// module chunks = 0